<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="footer-desc">
        全程陪伴您的毕业设计，提供从需求分析到答辩支持的全流程服务
      </div>
      <div class="footer-copy">
        © 2024 - present 极客码艺工作室 |
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">渝ICP备2025065693号</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>
.footer {
  background: linear-gradient(to right, #eff6ff, #faf5ff);
  border-top: 1px solid #e5e7eb;
  color: #4b5563;
}

.footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 18px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.footer-desc {
  font-size: 14px;
  color: #4b5563;
  text-align: center;
}

.footer-copy {
  font-size: 13px;
  color: #6b7280;
  text-align: center;
  white-space: nowrap;
}

.footer-copy a {
  color: #6b7280;
  text-decoration: none;
  transition: color 0.2s;
}

.footer-copy a:hover {
  color: #2563eb;
}
</style>
